import React from "react";
import styles from "./landingPageBiancaSilva.module.scss";
import { CheckCircle, Globe, CalendarCheck } from "lucide-react";
import { motion } from "framer-motion";

// Substitua essas imagens pelas reais na pasta src

const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
        opacity: 1,
        transition: {
            duration: 1,
            ease: "easeInOut",
            when: "beforeChildren",
            staggerChildren: 0.3
        }
    }
};

const itemVariants = {
    visible: { opacity: 1, scale: 1, transition: { duration: 0.6 } }
};

export default function LandingPageBiancaSilva() {
    return (
        <div className={styles.landingPageBiancaSilva}>
            <motion.section
                className={styles.container}
                variants={containerVariants}
                initial="hidden"
                animate="visible"
            >
                <motion.div className={styles.conteudoEsquerda} variants={itemVariants}>
                    <h1 className={styles.titulo}>Sua agenda, nas mãos de quem entende organização.</h1>
                    <p className={styles.subtitulo}>
                        Deixe que a gente cuida da sua rotina, enquanto você foca no que faz de melhor.
                    </p>

                    <ul className={styles.listaBeneficios}>
                        <li><CheckCircle className={styles.icone} /> Mais tempo para atender seus clientes</li>
                        <li><CheckCircle className={styles.icone} /> Atendimento sem atrasos ou sobrecargas</li>
                        <li><CheckCircle className={styles.icone} /> Agendamentos organizados e sem furos</li>
                        <li><CheckCircle className={styles.icone} /> Mais profissionalismo com seus pacientes</li>
                    </ul>

                    <div className={styles.sistemaInfo}>
                        <CalendarCheck className={styles.iconeSistema} />
                        <span>Utilizamos um sistema próprio de agendamento, exclusivo e otimizado para sua área de atuação.</span>
                    </div>

                    <button className={styles.botao}>Contratar agora</button>

                    <div className={styles.linkSite}>
                        <Globe className={styles.iconeGlobo} />
                        <span>www.linksvibe.com.br</span>
                    </div>
                </motion.div>

                <motion.div className={styles.conteudoDireita} variants={itemVariants}>
                    <div className={styles.imagemWrapper}>
                        <img src="#" alt="Bianca Silva" className={styles.imagemBianca} />
                    </div>
                </motion.div>
            </motion.section>
        </div>
    );
}
